import Button from "@/components/button/button";
import historyIcon from "../../assets/imgs/historyIcon.svg";
import styles from "../../ShopWidget.module.scss";
import { IUserBalance } from "../../types";
import { formatBalance } from "../../helpers";

type Props = {
  onHistoryClick?: () => void;
  userBalance: IUserBalance[];
  title?: string;
  description?: string;
};

const Header = ({ onHistoryClick, userBalance, title, description }: Props) => {
  return (
    <div className={styles.header}>
      <div className={styles.header__leftSide}>
        {title && <h2 className={styles.headerTitle}>{title}</h2>}
        {description && <p className={styles.headerDescription}>{description}</p>}
      </div>
      <div className={styles.header__rightSide}>
        <div className={styles.userBalances} data-count={userBalance.length}>
          {userBalance.map((item) => (
            <div key={item.token.id} className={`${styles.coins}`}>
              <span className={styles.tokenGlow}>
                <img
                  className={styles.tokenGlowImage}
                  src={item?.token?.image}
                  alt=""
                  aria-hidden="true"
                />
                <img className={styles.tokenImage} src={item?.token?.image} alt={item?.token?.name} />
              </span>
              <span className={styles.balance}>{formatBalance(item?.balance)}</span>
            </div>
          ))}
        </div>
        <div className={styles.history}>
          <Button
            img={historyIcon}
            label=""
            className={styles.historyButton}
            onClick={onHistoryClick}
          />
        </div>
      </div>
    </div>
  );
};

export default Header;
